/* eslint-disable no-unused-vars */
/*Configuration Import */
import apiService from "./apiservice";

/*Library Definition */
const registerApi = {
  /*Register member method */
  registerMember: (member, setIsLoading) => {
    return apiService
      .put("/onboard/simple/persist", member, {
        headers: { Authorization: "Token " + window.config.token },
      })
      .catch((error) => {
        setIsLoading((prevState) => false);
        console.log(error);
      });
  },
  /*load countries and states/provinces */
  getCountriesStates: () => {
    return apiService
      .get("listvalues/types/5F0FC061-1967-4214-838A-4AD576054C5B", {
        headers: { Authorization: "Token " + window.config.token },
      })
      .catch((error) => {
        console.log(error);
      });
  },
  /*load employment types */
  getEmploymentTypes: () => {
    return apiService
      .get("listvalues/types/F3F44B40-8CCF-4E59-8EBC-5C7BE5561C14", {
        headers: { Authorization: "Token " + window.config.token },
      })
      .catch((error) => {
        console.log(error);
      });
  },
  /*load roles */
  getRoles: () => {
    return apiService
      .get("listvalues/types/22B29248-4293-4F1C-8015-603F8C2EF622", {
        headers: { Authorization: "Token " + window.config.token },
      })
      .catch((error) => {
        console.log(error);
      });
  },
};

export default registerApi;
